module.exports = __webpack_public_path__ + "img/_logo-usps.com-full.ed808007.svg";